const onReady = {};

function onReadyRun() {
    for (let key in onReady) {
        if (!onReady.hasOwnProperty(key)) {
            continue;
        }
        let func = onReady[key];
        if (typeof func === "function") {
            func.call(); // Run function
        }
    }
}

export { onReady, onReadyRun };
